import React from "react";
import { Form, Select, Button, DatePicker } from "antd";

import get from "lodash/get";
import map from "lodash/map";
import find from "lodash/find";
import dayjs from "dayjs";

import { getButtonDisabled } from "../../../utilities/helpers";

const HeaderSelector = ({
  filter,
  setFilters,
  config,
  setConfig,
  getCompanyTemplates,
  form,
  setSelectedTemplate,
  setTemplates
}) => {
  const disabledDate = (current) => {
    return current > dayjs().endOf("day");
  };
  return (
    <div className="justify-end flex flex-wrap items-center h-full space-x-5 ">
      <Form.Item name="Company" label="Company" colon={false} layout="vertical">
        <Select
          style={{ width: 300 }}
          size="middle"
          value={get(filter, "company")}
          placeholder="Select Company"
          optionFilterProp="label"
          showSearch
          options={map(get(config, "companies"), (company) => ({
            label: get(company, "name"),
            value: get(company, "id"),
          }))}
          onChange={(val) => {
            const company = find(get(config, "companies"), ["id", val]);
            setFilters({
              ...filter,
              shift: undefined,
              templateType: undefined,
              company,
            });
            setConfig({
              ...config,
              templates: get(company, "template_access_list"),
              shifts: get(company, "company_shifts"),
            });
            form.setFieldsValue({
              template: undefined,
              shift: undefined,
            });
            setSelectedTemplate({
              template: undefined,
              graph_report: undefined,
              interval: 60,
            });
            setTemplates([])
          }}
        />
      </Form.Item>
      <Form.Item
        name="template"
        label="Template"
        colon={false}
        layout="vertical"
      >
        <Select
          style={{ minWidth: 250 }}
          size="middle"
          placeholder="Select Template"
          options={map(get(config, "templates"), (template) => ({
            label: get(template, "name"),
            value: get(template, "value"),
          }))}
          value={get(filter, "templateType")}
          onChange={(value) => {
            setFilters({
              ...filter,
              templateType: value,
            });
            setTemplates([])
          }}
        />
      </Form.Item>

      <Form.Item name="Date" label="Date" colon={false} layout="vertical">
        <DatePicker
          format={"DD/MM/YYYY"}
          disabledDate={disabledDate}
          style={{ minWidth: 250 }}
          onChange={(val) => {
            setFilters({
              ...filter,
              date: val,
            });
            setTemplates([])
          }}
          defaultValue={get(filter, "date")}

        />
      </Form.Item>
      <Form.Item name="shift" label="Shift" colon={false} layout="vertical">
        <Select
          style={{
            minWidth: 200,
          }}
          size="middle"
          placeholder="Select Shift"
          disabled={getButtonDisabled(filter, ["templateType", "company"])}
          value={get(filter, "shift.id")}
          options={map(get(config, "shifts", []), (shift) => ({
            label: get(shift, "name"),
            value: get(shift, "id"),
          }))}
          onChange={(value) => {
            const selecteShift = find(get(config, "shifts"), ["id", value]);
            setFilters({ ...filter, shift: selecteShift });
          }}
        />
      </Form.Item>
      <Form.Item name="submit" label=" " colon={false} layout="vertical">
        <Button
          type="primary"
          className="w-auto"
          onClick={getCompanyTemplates}
          disabled={getButtonDisabled(filter, [
            "templateType",
            "company",
            "date",
            "shift",
          ])}
        >
          Submit
        </Button>
      </Form.Item>
    </div>
  );
};

export default HeaderSelector;
